export const BASE_URL = "https://tmsapi.raychemrpg.com/tms-core";

//export const BASE_URL = "http://172.19.12.4/tms-core";

// export const BASE_URL = "http://localhost:8080/tms-core";

// verify otp
export const VERIFY_OTP = `${BASE_URL}/verify-otp`;

// resend otp
export const RESEND_OTP = `${BASE_URL}/resend-otp`;

// add visitor data
export const ADD_VISITOR = `${BASE_URL}/visitor`;

// get jointer details
export const GET_JOINTER = `${BASE_URL}/search/jointer`;

// download QR code
export const DOWNLOAD_QR = `${BASE_URL}/jointer/qr`;

// download Authorization letter QR code
export const DOWNLOAD_Authorization_QR = `${BASE_URL}/jointer/certificates`;

// logout from portal
export const VISITOR_LOGOUT = `${BASE_URL}/visitor-logout`;